var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end mt-3 mb-4"
  }, [_c('div', [_c('b-button', {
    staticClass: "ml-0 ml-xl-4",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('span', {
    staticClass: "mdi mdi-file-excel mr-1"
  }), _vm._v(" 匯出 Excel ")])], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" 進階搜尋"), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', {}, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "填寫內容",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋填寫內容",
      "disabled": _vm.loading
    },
    model: {
      value: _vm.query.res_keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "res_keyword", $$v);
      },
      expression: "query.res_keyword"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "會員名稱",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋會員名稱",
      "disabled": _vm.loading
    },
    model: {
      value: _vm.query.customer_name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer_name", $$v);
      },
      expression: "query.customer_name"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "會員編號",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋會員編號",
      "disabled": _vm.loading
    },
    model: {
      value: _vm.query.customer_outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer_outer_code", $$v);
      },
      expression: "query.customer_outer_code"
    }
  })], 1), _vm._l(_vm.dynamicCustomerFields, function (field) {
    return _c('b-form-group', {
      key: field.key,
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "label": field.label,
        "label-cols-sm": "3",
        "label-cols-lg": "2",
        "content-cols-sm": "",
        "content-cols-lg": "7"
      }
    }, [_c('b-form-input', {
      staticClass: "mr-3",
      attrs: {
        "placeholder": "\u641C\u5C0B".concat(field.label),
        "disabled": _vm.loading
      },
      model: {
        value: _vm.query[field.queryKey],
        callback: function callback($$v) {
          _vm.$set(_vm.query, field.queryKey, $$v);
        },
        expression: "query[field.queryKey]"
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "flex-column"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置搜尋條件 ")]), _c('b-button', {
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.results,
      "fields": _vm.fields,
      "busy": _vm.loading
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(customer_name)",
      fn: function fn(data) {
        var _data$item$customer$n, _data$item$customer;
        return [_c('TableCell', {
          attrs: {
            "content": (_data$item$customer$n = (_data$item$customer = data.item.customer) === null || _data$item$customer === void 0 ? void 0 : _data$item$customer.name) !== null && _data$item$customer$n !== void 0 ? _data$item$customer$n : '',
            "title": _vm.fields.find(function (f) {
              return f.key === 'customer_name';
            }).label
          }
        })];
      }
    }, {
      key: "cell(outer_code)",
      fn: function fn(data) {
        var _data$item$customer$o, _data$item$customer2;
        return [_c('TableCell', {
          attrs: {
            "content": (_data$item$customer$o = (_data$item$customer2 = data.item.customer) === null || _data$item$customer2 === void 0 ? void 0 : _data$item$customer2.outer_code) !== null && _data$item$customer$o !== void 0 ? _data$item$customer$o : '',
            "title": _vm.fields.find(function (f) {
              return f.key === 'outer_code';
            }).label
          }
        })];
      }
    }, {
      key: "cell()",
      fn: function fn(data) {
        return [data.value !== undefined ? _c('TableCell', {
          attrs: {
            "content": data.value,
            "title": _vm.fields.find(function (f) {
              return f.key === data.field.key;
            }).label
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.created_at)) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.FORM_RESULT_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteResult(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }